import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { TPaths } from "../../../../app";
import en from './en.json';
import ru from './ru.json';

const accessDeniedPageTranslationNs = 'accessDeniedPage' as const;

i18next.addResourceBundle('en', accessDeniedPageTranslationNs, en);
i18next.addResourceBundle('ru', accessDeniedPageTranslationNs, ru);

declare module 'i18next' {
    interface i18nResources {
        [accessDeniedPageTranslationNs]: typeof en;
    }
    interface CustomTypeOptions {
        // custom namespace type if you changed it
        // defaultNS: "ns1"
        // custom resources type
        resources: i18nResources;
    }
}

export type TAccessDeniedPageTranslationPaths = TPaths<typeof en> &
    TPaths<typeof ru>;

export function useAccessDeniedPageTranslations(): (
    key: TAccessDeniedPageTranslationPaths,
    options?: Record<string, string | number>
) => string {
    const { t } = useTranslation(accessDeniedPageTranslationNs);
    return t;
}
